import React from 'react';
import { ChevronUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-black border-t border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="text-center mb-8" data-testid="footer-hours">
          <h3 className="text-sm tracking-widest text-white/60 mb-4">OPENING HOURS</h3>
          <div className="text-white text-base sm:text-lg space-y-1 tracking-wider">
            <p>MON-TUE: 10AM - 5PM</p>
            <p>WED: CLOSED</p>
            <p>THU-SAT: 10AM - 5PM</p>
            <p>SUN: CLOSED</p>
          </div>
        </div>
        {/* Single Row Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-6 border-t border-white/10">
          <p className="text-white/60 text-sm">
            © {new Date().getFullYear()} Atlantic Coast Tattoo. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm tracking-wider"
          >
            <ChevronUp size={20} />
            BACK TO TOP
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;